import {useLocation, useParams} from "react-router";
import React, {Component} from 'react';

export default function withParams(Component) {
	return props => <Component {...props} location={useLocation()} params={useParams()} />;
}